import { render, staticRenderFns } from "./GoToGradebookCell.vue?vue&type=template&id=0118bcb7&"
import script from "./GoToGradebookCell.vue?vue&type=script&lang=js&"
export * from "./GoToGradebookCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports